
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/sobre-nosotros",
      function () {
        return require("private-next-pages/es/sobre-nosotros.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/sobre-nosotros"])
      });
    }
  